<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-radio-group
                :options="data.form.tipoImpressaoAgendamento"
                :label="false"
                name="Impressão agendamento de exame"
                v-model="data.model.impressaoAgendamentoTipoId"
                :validations="validations.impressaoAgendamento"
                text-field="descricao"
                value-field="id"
                class="pt-0"
            />
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                impressaoAgendamento: { required: true},
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>